"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECTABLE_MODEL_NAMES = exports.MODEL_OPTIONS = exports.DEFAULT_MODEL = void 0;
var _process$env$NEXT_PUB;
var SELECTABLE_MODEL_NAMES = exports.SELECTABLE_MODEL_NAMES = ["claude-opus-5-5", "claude-sonnet-5-5", "claude-sonnet-5"];
var MODEL_LABELS = {
  "claude-opus-5-5": "Claude Opus 5.5 (Latest)",
  "claude-sonnet-5-5": "Claude Sonnet 5.5",
  "claude-sonnet-5": "Claude Sonnet 5"
};
var MODEL_OPTIONS = exports.MODEL_OPTIONS = SELECTABLE_MODEL_NAMES.map(function (name) {
  return {
    value: name,
    label: MODEL_LABELS[name]
  };
});
var DEFAULT_MODEL = exports.DEFAULT_MODEL = ((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_DEFAULT_CHAT_MODEL) === null || _process$env$NEXT_PUB === void 0 ? void 0 : _process$env$NEXT_PUB.trim()) || "claude-sonnet-5";